module.exports = __webpack_public_path__ + "media/device_images/iphone-player-profile-summary-b0dd26b0.jpg";